import { Component, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { ActivatedRoute } from '@angular/router';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';

@Component({
  selector: 'scanner-ticket-component',
  styleUrls: ['../cashout/cashout.new.sass'],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './scanner-ticket.component.html',
})
export class ScannerTicketComponent implements AfterViewInit {
  slipId: number;
  slipDetailList = [];
  couponDetailList = [];
  isLive = false;

  constructor(
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _ApiService: ApiService,
    private route: ActivatedRoute,
    private _DataHelper: DataHelper,
    public _LZ: LocalizationService,
    private _Router: Router
  ) {
    this.route.params.subscribe(params => {
      this.slipId = params['slipid'];
      ////console.log("SLIP_ID", this.slipId);
    });
  }

  ngAfterViewInit() {
    this.getSlipDetail();

    this._UiHelper.setNavbarTitle('betting_slip_details');
  }

  getSlipDetail() {
    this._ApiService.getScannerSlipDetail(this.slipId).then(x => {
      this.slipDetailList = x;
      this.isLive = x.filter((i: any) => i.BetTypeId === 1).length > 0;
    });

    this._ApiService.getScannerSlipOneBySlipId(this.slipId).then(x => {
      if (x == undefined) return;
      if (x == '') return;

      this.couponDetailList = x;
    });
  }

  getLiveEvent(e) {
    if (this._DataHelper.liveData != undefined) {
      const match = this._DataHelper.liveData.find(m => m.BetradarMatchId == e);
      return match;
    }
  }

  goLiveEventDetail(e) {
    this._Router.navigate(['/liveeventdetail', e]);
  }

  goEventDetail(e) {
    this._Router.navigate(['/eventdetail', e]);
  }

  reverse(e) {
    if (e.indexOf(':') > -1) {
      return e.split(':')[1] + ':' + e.split(':')[0];
    } else return e;
  }

  trackBySlipId(index: number, item: any) {
    return item.BetradarMatchId;
  }
}
